export default __webpack_public_path__ + "static/media/48t.e3853d1e.jpg";